export default __webpack_public_path__ + "static/media/ads2.7c1c5c65.jpg";